import React, { useState } from "react";
import DatePicker from "react-multi-date-picker";
import PropTypes from "prop-types";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import moment from "moment";
import momentTz from "moment-timezone";

function MultipleDatePicker(props) {
  const [values, setValues] = useState( props.defaultValue);
  // weird bug makes the date picker not work when the minDate is set to today
  const [minDate, setMinDate] = useState(moment().add(1, "day"));

  return (<DatePicker
    error={props.error}
    plugins={props.single? undefined : [<DatePanel />]}
    style={{
      height: "32px", borderRadius: "8px", fontSize: "14px", padding: "8px"
    }}
    className="primary-color"
    minDate={momentTz().tz("Australia/Brisbane").startOf('d').toISOString()}
    multiple={!props.single}
    weekStartDayIndex={1}
    format={props.format || "DD/MM/YYYY"}
    value={values}
    onChange={values => {
      const dates = values;

      if (props.single) {
        setValues(dates);
        props.setDates(moment(dates.toDate()).toISOString());
      } else {
        if (dates.length) {
        const filteredDates = dates.filter(date => minDate.isBefore(moment(date.toDate())));
        setValues(dates);
        props.setDates(dates.map(date => moment(date.toDate()).toISOString()));
        }
      }
    }}
  />);
}

export default MultipleDatePicker;

MultipleDatePicker.propTypes = {
  defaultValue: PropTypes.array,
  single: PropTypes.bool,
  title: PropTypes.string,
  format: PropTypes.string,
  setDates: PropTypes.func.isRequired
};
